import 'es6-promise/auto';
import Vue from 'vue';
// Import Bootstrap Vue components and directives
import {
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCarousel,
    BCarouselSlide,
    BCol,
    BCollapse,
    BEmbed,
    BModal,
    BRow,
    BSpinner,
    BTooltip,
    VBModal,
    VBToggle,
    VBTooltip
} from 'bootstrap-vue';

import moment from 'moment';
import 'moment/locale/en-gb';
import VueMoment from 'vue-moment';
import VeeValidate from 'vee-validate';
import VueScrollTo from 'vue-scrollto';
import Toasted from 'vue-toasted';
import dictionary from 'js/lib/form-dictionary';
import './api';
import './filters';
import store from './store';
import router from './router';
import App from './App';
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// Import Custom Vue Components
import Button from './components/Button';
import SVGSprite from './components/SVGSprite';
import Forbidden from './components/Forbidden';

// Register Bootstrap Vue and custom components and directives globally
Vue.component('b-modal', BModal);
Vue.component('b-row', BRow);
Vue.component('b-col', BCol);
Vue.component('b-carousel', BCarousel);
Vue.component('b-carousel-slide', BCarouselSlide);
Vue.component('b-collapse', BCollapse);
Vue.component('b-card', BCard);
Vue.component('b-card-header', BCardHeader);
Vue.component('b-card-body', BCardBody);
Vue.component('b-embed', BEmbed);
Vue.component('b-tooltip', BTooltip);
Vue.component('b-spinner', BSpinner);
Vue.component('b-btn', BButton);
Vue.component('MButton', Button);
Vue.component('SVGSprite', SVGSprite);
Vue.component('Forbidden', Forbidden);
Vue.directive('b-modal', VBModal);
Vue.directive('b-toggle', VBToggle);
Vue.directive('b-tooltip', VBTooltip);

Vue.use(VueMoment, {
    moment
});
Vue.use(VeeValidate, {
    dictionary
});
Vue.use(VueScrollTo);

Vue.use(Toasted, {
    position: 'top-center',
    fullWidth: true,
    duration: 7000,
    containerClass: 'toasted-moea',
    keepOnHover: true,
    router
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>',
    store
});
